
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Spinner2384028367",
      {"classes":{"root":"Spinner2384028367__root","circle":"Spinner2384028367__circle"},"vars":{"wix-color-5":"--wix-color-5","wix-ui-tpa-spinner-path-color":"--wix-ui-tpa-spinner-path-color","wix-ui-tpa-spinner-diameter":"--wix-ui-tpa-spinner-diameter","diameter":"--Spinner2384028367-diameter"},"stVars":{},"keyframes":{"rotate":"Spinner2384028367__rotate","dash":"Spinner2384028367__dash"},"layers":{}},
      "",
      -1,
      module.id
  );
  